import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import Login from './auth/Login';
import Dashboard from './dashboard/Dashboard';
import CoordinatorDashboard from './dashboard/CoordinatorDashboard';
import './App.css';

function ProtectedRoute({ children }) {
    const { currentUser, userRole } = useAuth();

    if (!currentUser || (userRole !== 'admin' && userRole !== 'coordinator')) {
        return <Navigate to="/login" />;
    }

    return children;
}

function AppRoutes() {
    const { userRole } = useAuth();

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="/dashboard/*"
                element={
                    <ProtectedRoute>
                        {userRole === 'admin' ? <Dashboard /> : <CoordinatorDashboard />}
                    </ProtectedRoute>
                }
            />
            <Route path="/" element={
                userRole ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
            } />
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
